import React, { useState } from "react";
import getConfig from "next/config";
import Router from "next/router";
import Button from "../components/Button";
import Select from "./FormGeneric/Select";
import FormError from "./FormGeneric/FormError";
import BrickListItem from "./Icons/BrickListItem";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const options = {
  age: {
    key: "varsta-8282",
    values: [
      {
        name: "1-2 ani",
        key: "1-2-ani",
      },
      {
        name: "3-4 ani",
        key: "3-4-ani",
      },
      {
        name: "5-7 ani",
        key: "5-6-ani_6-7-ani_7-8-ani",
      },
      {
        name: "8-12 ani",
        key: "8-9-ani_9-10-ani_10-11-ani_11-12-ani",
      },
      {
        name: "12-14-ani",
        key: "peste-12-ani",
      },
      {
        name: ">12 ani",
        key: "peste-12-ani",
      },
    ],
  },
  price: {
    key: "price",
    values: [
      {
        name: "Sub 50",
        key: "0-50",
      },
      {
        name: "50-100",
        key: "50-100",
      },
      {
        name: "100-200",
        key: "100-200",
      },
      {
        name: "200-500",
        key: "200-500",
      },
      {
        name: "500-1000",
        key: "500-1000",
      },
      {
        name: "1000-1500",
        key: "1000-1500",
      },
      {
        name: "1500-2000",
        key: "1500-2000",
      },
      {
        name: "2000-3000",
        key: "2000-3000",
      },
      {
        name: "Peste 3000",
        key: "3000-4000",
      },
    ],
  },
  interest: {
    key: "interese-9351",
    values: [
      {
        img: "spatiu",
        key: "spatiu",
        color: "#2D3A8C",
      },
      {
        img: "sport",
        key: "sport",
        color: "#FF9D00",
      },
      {
        img: "supereroi",
        key: "super-eroi",
        color: "#EC3333",
      },
      {
        img: "animale",
        key: "animale",
        color: "#808F89",
      },
      {
        img: "decor",
        key: "decor",
        color: "#C9712D",
      },
      {
        img: "dinozauri",
        key: "dinozauri",
        color: "#708D00",
      },
      {
        img: "casute",
        key: "casute",
        color: "#00569F",
      },
      {
        img: "cinema",
        key: "cinema",
        color: "#C60102",
      },
      {
        img: "ninja",
        key: "ninja",
        color: "#B50806",
      },
      {
        img: "printese",
        key: "printese",
        color: "#F6CC00",
      },
      {
        img: "gaming",
        key: "jocuri-video",
        color: "#C96DFD",
      },
      {
        img: "masinute",
        key: "masini",
        color: "#625D59",
      },
    ],
  },
};

const getProductSearchURL = ({ age = "", price = "", interests = [] }) => {
  let ageQuery = "";
  let priceQuery = "";
  let interestsQuery = "";

  if (age) ageQuery = `${options.age.key}/${age}/`;
  if (price) priceQuery = `${options.price.key}/${price}/`;
  if (interests.length)
    interestsQuery = `${options.interest.key}/${interests.join("_")}/`;

  return `/lego-jucarii/cpl/filtru/${ageQuery}${priceQuery}${interestsQuery}`;
};

const LegoWizard = () => {
  const [selectedAge, setAge] = useState("");
  const [selectedPrice, setPrice] = useState("");
  const [selectedInterests, setInterests] = useState([]);
  const [error, setError] = useState("");

  const resetError = () => setError("");

  const searchProducts = () => {
    if (!selectedAge && !selectedPrice && !selectedInterests.length) {
      setError("Selecteaza mai intai varsta, pretul sau un interes.");
      return;
    }

    const url = getProductSearchURL({
      age: selectedAge,
      price: selectedPrice,
      interests: selectedInterests,
    });

    Router.push(url);
  };

  const handleSetInterest = (key) => {
    if (selectedInterests.includes(key)) {
      setInterests(
        selectedInterests.filter((interestKey) => interestKey !== key)
      );
    } else {
      setInterests(selectedInterests.concat(key));
    }

    if (error) resetError();
  };

  const handleSetAge = (key) => {
    setAge(key);
    if (error) resetError();
  };

  const handleSetPrice = (key) => {
    setPrice(key);
    if (error) resetError();
  };

  return (
    <>
      <div className="mb-8 sm:max-w-[60%] md:max-w-[35%]">
        <img
          src={`${settings.websiteStatics}/images/universul-lego/wizzard_title.png`}
          alt=""
        />
      </div>

      <div className="flex flex-col lg:flex-row mb-8">
        <div className="flex flex-col sm:flex-row mb-6 lg:mb-0">
          <div className="flex flex-grow flex-col sm:flex-row mb-4 sm:mb-0 sm:items-center mr-0 sm:mr-8">
            <div className="flex items-center mb-3 sm:mb-0">
              <div className="mr-3">
                <BrickListItem number={1} />
              </div>

              <label htmlFor="age" className="mr-4">
                Varsta
              </label>
            </div>

            <Select
              id="age"
              onChange={(event) => handleSetAge(event.target.value)}
            >
              <option value="">Alege varsta</option>

              {options.age.values.map(({ name, key }, index) => (
                <option key={index} value={key}>
                  {name}
                </option>
              ))}
            </Select>
          </div>

          <div className="flex flex-grow flex-col sm:flex-row sm:items-center mr-0 sm:mr-8">
            <div className="flex items-center mb-3 sm:mb-0">
              <div className="mr-3">
                <BrickListItem number={2} />
              </div>

              <label htmlFor="price" className="mr-4">
                Pret
              </label>
            </div>

            <Select
              id="price"
              onChange={(event) => handleSetPrice(event.target.value)}
            >
              <option value="">Alege pretul</option>

              {options.price.values.map(({ name, key }, index) => (
                <option key={index} value={key}>
                  {name} RON
                </option>
              ))}
            </Select>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center">
          <div className="mb-3 sm:mb-0 mr-3">
            <BrickListItem number={3} />
          </div>

          <div>
            <label className="mb-0">Interese</label>
            <div className="md:text-sm text-gray-dark">
              Selecteaza dintre categoriile de mai jos
            </div>
          </div>
        </div>
      </div>

      <ul className="grid grid-rows-2 grid-flow-col overflow-x-scroll gap-4 md:grid-flow-row md:grid-rows-none md:grid-cols-4 lg:grid-cols-6 px-4 py-5">
        {options.interest.values.map(({ img, key, color }, index) => {
          const isSelected = selectedInterests.includes(key);
          return (
            <li
              key={index}
              className={`relative w-40 sm:w-48 md:w-auto cursor-pointer ${
                isSelected ? "shadow-lg" : ""
              }`}
              onClick={() => handleSetInterest(key)}
            >
              <img
                src={`${settings.websiteStatics}/images/universul-lego/interese/${img}.png`}
                alt=""
              />

              {isSelected && (
                <>
                  <span
                    className="pointer-events-none absolute inset-0 border-2"
                    style={{ borderColor: color }}
                  />
                  <span
                    className="pointer-events-none absolute top-2 right-2 w-5 h-5 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: color }}
                  >
                    <svg
                      viewBox="0 0 24 24"
                      className="w-3 h-3"
                      fill="none"
                      stroke="white"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="5 12 10 17 19 8" />
                    </svg>
                  </span>
                </>
              )}
            </li>
          );
        })}
      </ul>

      <div className="sm:text-center mt-4">
        <Button
          onClick={searchProducts}
          title="Vezi produsele"
          disabled={Boolean(error)}
        />

        {error && <FormError>{error}</FormError>}
      </div>
    </>
  );
};

export default LegoWizard;
